export const SITE_NAV_ID = 'main';
